<template>
  <div class="main_box">
    <div class="body_title flex_layout_between">
      <div class="message_head">
        <div class="head_left">
          <span class="order_number">{{ $t('enum.orderNumber') }}: {{ Detail.Code ? Detail.Code : '-' }}</span>
          <div class="order_pt">
            <!-- <div class="to_be_paid">{{Detail.StatusMsg}}</div> -->
            <div class="to_be_paid" :class="[Detail['OrderStatus'] >= 2 ? 'to_be_paid2' : '', timeCountDown(Detail.CountDown) == '00:00' ? 'text_red' : 'text_orange']">
              {{ $store.state.OrderStatus[Detail['OrderStatus']] }}
            </div>
            <div class="Remaining_time" :class="Detail['OrderStatus'] == 1 && timeCountDown(Detail.CountDown) == '00:00' ? 'text_red Remaining_red' : 'text_orange'" v-if="Detail['OrderStatus'] == 1">
              <!-- Remaining: {{ endingTime(Detail.LastPayDate) }} -->
              <span class="count_down">{{ Detail.CountDownType == 1 ? "Remaining" : "Auto-closed by system" }}: {{ timeCountDown(Detail.CountDown) }}</span>
            </div>
            <el-button class="edit_fee" v-if="Detail['OrderStatus'] == 1" @click="dialogBox('EditShippingFee', Detail)">Edit Shipping Fee</el-button>
          </div>

        </div>
        <div class="head_right">
          <div style="display:flex; justify-content: flex-start;">
            <div>
              <div class="planned_speed">
                <i class="submit" :class="OrderStatus > 0 ? 'submit_green' : ''"></i>
                <span class="small_dot dot" :class="OrderStatus > 0 ? 'dot_green' : ''"></span>
                <span class="small_dot dot" :class="OrderStatus > 0 ? 'dot_green' : ''"></span>
              </div>
              <span class="submit_orders name_black">{{ $t('enum.submitOrders') }}</span>
              <div class="align_c" :class="timeSpeed(OrderStatus)">
                <span class="time" v-if="!Status1">{{ Detail['CreateDate'] ? $store.getters.getTime(Detail['CreateDate'], $store.state.lang.indexOf("zh") > -1 ? 8 : -8, '', $store.state.lang.indexOf("zh") > -1 ? '' : 'MMM DD, YYYY HH:mm') : '' }}</span>
                <!-- <span class="time" v-if="!Status1">{{Detail['CreateDate']?$store.getters.getTime(Detail['CreateDate']):''}}</span> -->
              </div>
            </div>
            <span class="big_dot dot" :class="OrderStatus > 0 ? 'dot_green' : ''" style="margin: 6px 0 0 20px;"></span>
            <!-- ***************** Submit Orders ***************** -->

            <div class="plannedSpeed">
              <div class="planned_speed">
                <span class="small_dot dot" :class="OrderStatus >= 2 && OrderStatus < 6 && Detail['PayDate'] ? 'dot_green' : ''"></span>
                <span class="small_dot dot dot_right" :class="OrderStatus >= 2 && OrderStatus < 6 && Detail['PayDate'] ? 'dot_green' : ''"></span>
                <i class="order" :class="OrderStatus >= 2 && OrderStatus < 6 && Detail['PayDate'] ? 'order_green' : ''"></i>
                <span class="small_dot dot" :class="OrderStatus >= 2 && OrderStatus < 6 && Detail['PayDate'] ? 'dot_green' : ''"></span>
                <span class="small_dot dot" :class="OrderStatus >= 2 && OrderStatus < 6 && Detail['PayDate'] ? 'dot_green' : ''"></span>
              </div>
              <span class="pay_for_order name_black">{{ $t('enum.payForOrder') }}</span>
              <div class="align_c" :class="timeSpeed(OrderStatus)">
                <span class="time" v-if="!Status1">{{ Detail['PayDate'] ? $store.getters.getTime(Detail['PayDate'], $store.state.lang.indexOf("zh") > -1 ? 8 : -8, '', $store.state.lang.indexOf("zh") > -1 ? '' : 'MMM DD, YYYY HH:mm') : '' }}</span>
                <!-- <span class="time" v-if="!Status2">{{Detail['PayDate']?$store.getters.getTime(Detail['PayDate']):''}}</span> -->
              </div>
            </div>
            <span class="big_dot dot" :class="OrderStatus >= 2 && OrderStatus < 6 && Detail['PayDate'] ? 'dot_green' : ''"></span>
            <!-- ***************** Pay For Order ***************** -->

            <div class="plannedSpeed">
              <div class="planned_speed">
                <span class="small_dot dot" :class="OrderStatus >= 3 && OrderStatus < 6 && Detail['SendTime'] ? 'dot_green' : ''"></span>
                <span class="small_dot dot dot_right" :class="OrderStatus >= 3 && OrderStatus < 6 && Detail['SendTime'] ? 'dot_green' : ''"></span>
                <i class="car" :class="OrderStatus >= 3 && OrderStatus < 6 && Detail['SendTime'] ? 'car_green' : ''"></i>
                <span class="small_dot dot" :class="OrderStatus >= 3 && OrderStatus < 6 && Detail['SendTime'] ? 'dot_green' : ''"></span>
                <span class="small_dot dot" :class="OrderStatus >= 3 && OrderStatus < 6 && Detail['SendTime'] ? 'dot_green' : ''"></span>
              </div>
              <span class="seller_shipped name_black">{{ $t('enum.shipped') }}</span>
              <div class="align_c" :class="timeSpeed(OrderStatus)">
                <span class="time" v-if="!Status1">{{ Detail['SendTime'] ? $store.getters.getTime(Detail['SendTime'], $store.state.lang.indexOf("zh") > -1 ? 8 : -8, '', $store.state.lang.indexOf("zh") > -1 ? '' : 'MMM DD, YYYY HH:mm') : '' }}</span>
                <!-- <span class="time" v-if="!Status3">{{Detail['SendTime']?$store.getters.getTime(Detail['SendTime']):''}}</span> -->
              </div>
            </div>
            <span class="big_dot dot" :class="OrderStatus >= 3 && OrderStatus < 6 && Detail['SendTime'] ? 'dot_green' : ''"></span>
            <!-- ***************** Seller Shipped ***************** -->

            <div class="plannedSpeed">
              <div class="planned_speed">
                <span class="small_dot dot" :class="OrderStatus >= 4 && OrderStatus < 6 && Detail['AcceptTime'] ? 'dot_green' : ''"></span>
                <span class="small_dot dot dot_right" :class="OrderStatus >= 4 && OrderStatus < 6 && Detail['AcceptTime'] ? 'dot_green' : ''"></span>
                <i class="finish" :class="OrderStatus >= 4 && OrderStatus < 6 && Detail['AcceptTime'] ? 'finish_green' : ''"></i>
              </div>
              <span class="finished name_black">{{ $t('enum.finish') }}</span>
              <div class="align_c" :class="timeSpeed(OrderStatus)">
                <span class="time" v-if="!Status1">{{ Detail['AcceptTime'] ? $store.getters.getTime(Detail['AcceptTime'], $store.state.lang.indexOf("zh") > -1 ? 8 : -8, '', $store.state.lang.indexOf("zh") > -1 ? '' : 'MMM DD, YYYY HH:mm') : '' }}</span>
                <!-- <span class="time" v-if="!Status4">{{Detail['AcceptTime']?$store.getters.getTime(Detail['AcceptTime']):''}}</span> -->
              </div>
            </div>
            <!-- ***************** Finish ***************** -->
          </div>
        </div>
      </div>
      <div class="info_box">
        <div class="buyer_info_box list_box">
          <div class="buyer_info info_font_size">{{ $t('enum.buyerInfo') }}</div>
          <div class="info">
            <div class="tick_name_box info_lists">
              <span class="lists">{{ $t('enum.ID') }}</span>
              <div class="user_name_box" @click="blackUserDialog(Detail)">
                <el-image class="user_img" :src="Detail.BuyerHeadPortrait + $store.state.thumbnail" fit="cover"></el-image>
                {{ Detail.BuyerName }}
                <!-- <em class="to-be-black" @click="blackUserDialog(Detail)"></em> -->
              </div>
            </div>
            <div class="thipping_name_box info_lists">
              <span class="lists">{{ $t('enum.fullName') }}</span>
              <span>{{ Detail.Consignee ? Detail.Consignee : '' }}&nbsp;{{ Detail.Mobile ? Detail.Mobile : '' }}</span>
            </div>
          </div>
          <div class="info">
            <div class="shipping_address_box info_lists">
              <span class="lists">{{ $t('enum.shippingAddress') }}</span>
              <div class="info-block">
                <p>{{ Detail.Nation ? Detail.Nation : '' }}{{ Detail.City ? ' - ' + Detail.City : '' }}</p><span v-if="Detail.Nation != null">,
                  &nbsp;</span>
                <p v-if="Detail.Provice">{{ Detail.Provice }}</p><span v-if="Detail.Provice != null">, &nbsp;</span>
                <p v-if="Detail.Address">{{ Detail.Address }}</p>
                <p v-if="Detail.ZipCode">&nbsp;{{ Detail.ZipCode }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="transport_box list_box">
          <div class="transport_info info_font_size">{{ $t('enum.transportInfo') }}</div>
          <div class="info">
            <div class="tarrier_name_box info_lists">
              <span class="lists">{{ $t('enum.carrier') }}</span>
              <span>{{ Detail.ExpressName ? Detail.ExpressName : '-' }}</span>
            </div>
            <div class="tracking_name_box info_lists">
              <span class="lists">{{ $t('enum.trackingNumber') }}</span>
              <span>{{ Detail.Express ? Detail.Express : '-' }}</span>
            </div>
          </div>
        </div>
        <div class="review_box list_box">
          <div class="review info_font_size">{{ $t('enum.feedback') }}</div>
          <div class="info">
            <div class="from_buyer_box info_lists">
              <span class="lists">{{ $t('enum.paymentMethod') }}</span>
              <span>{{ Detail.PayType ? ($store.state.PayType[Detail.PayType] || '-') : '-' }}</span>
            </div>
            <div class="from_seller_box info_lists">
              <span class="lists">{{ $t('enum.timeOfPayment') }}</span>
              <span>{{ Detail['PayDate'] ? $store.getters.getTime(Detail['PayDate']) : '-' }}</span>
            </div>
          </div>
        </div>
      </div>
      <message-list :list="Detail.Details" :USDRate="Detail.USDRate" :SellRealMoneyUnit="'USD'" showType="scheduled" />

      <div class="total_price">
        <div class="item_price_box">
          <span class="item_price">{{ $t('enum.itemPrice') }}:</span>
          <span>USD {{ Detail.USDRate ? (Detail.LowestPrice * Detail.USDRate).toFixed(2) : 0 }}</span>
        </div>
        <div class="shipping_fee_box">
          <span class="shipping_fee">{{ $t('enum.shippingFee') }}:</span>
          <span>USD {{ Detail.USDRate ? (Detail.PostageMoney * Detail.USDRate).toFixed(2) : 0 }}</span>
        </div>
        <div class="total_box">
          <span class="total">{{ $t('enum.orderTotal') }}:</span>
          <span>USD {{ Detail.USDRate ? (Detail.TotalPrice * Detail.USDRate).toFixed(2) : 0 }}</span>
        </div>
      </div>
    </div>
    <dialog-order ref="DialogOrder" @dialogBox="dialogBox" :dialogTitle="dialogTitle" @DialogSwitch="DialogSwitch"></dialog-order>
    <!-- #region 黑名单-拉黑用户 -->
    <el-dialog :title="`${$t('button.block')} ${blackItem.RealName || ''}?`" :visible.sync="dialogBlackVisible" @close="dialogBlackVisible = false; blackItem = {}">
      <div style="padding: 20px">{{ $t('enum.blockTips') }}</div>
      <div slot="footer">
        <el-button @click="dialogBlackVisible = false; blackItem = {}">{{ $t('button.cancel') }}</el-button>
        <el-button type="primary" @click="blackUser(blackItem)">{{ $t('button.block') }}</el-button>
      </div>
    </el-dialog>
    <!-- #endregion -->
  </div>
</template>

<script>
import MessageList from "@/components/messagelist";
import DialogOrder from '@/components/dialog/dialog-order'

export default {
  name: "",
  components: { MessageList, DialogOrder },
  data() {
    return {
      Id: '',
      Detail: {},
      dialogTitle: '',
      ReceiverAddress: {},
      Status1: true,
      Status2: true,
      Status3: true,
      Status4: true,
      timer: "",
      nowData: new Date().getTime(),
      OrderStatus: 0, // OrderStatus:6 -> 0 订单关闭
      timeLeng: 0,//秒倒计时累加
      dialogBlackVisible: false,//拉黑用户
      blackItem: {},//拉黑用户信息
    };
  },
  created: function () {
    var that = this;
    var _id = that.$route.query.id || '';
    that.Id = _id;
    that.getData('OrderDetail', `?OrderID=${_id}`);
    this.cardTimer();
  },
  mounted() {
    var that = this;
  },
  computed: {},
  methods: {
    // 订单完成状态
    timeSpeed(val) {
      if (val == 1) {
        this.Status1 = false
      }
      else if (val <= 2) {
        this.Status1 = false
        this.Status2 = false
      }
      else if (val <= 3) {
        this.Status1 = false
        this.Status2 = false
        this.Status3 = false
      }
      else if (val >= 4) {
        this.Status1 = false
        this.Status2 = false
        this.Status3 = false
        this.Status4 = false
      }
    },
    // 获取订单详情
    getData(api, params = "") {
      var that = this;
      var fun = "", method = "GET";
      that.loading = true;
      switch (api) {
        case "OrderDetail": //获取详细
          fun = function (res) {
            if (res.result) {
              that.$nextTick(() => {
                that.Detail = res.data;
                console.log("that.Detail:", that.Detail);
                var _OrderStatus = res.data.OrderStatus;
                that.OrderStatus = _OrderStatus ? _OrderStatus : 0;
              });
            }
          };
          break;
        default:
          break;
      }
      that.$get(api, params)
        .then((res) => {
          console.log("axios-res:", api, res);
          fun(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 修改运费、填写运输信息 弹框
    dialogBox(type, obj) {
      let that = this;
      // console.log('CardInfo:', obj);
      switch (type) {
        case 'Ship'://填写运输信息
          that.dialogTitle = "Ship";
          //that..... 获取快递列表
          break;
        case 'EditShippingFee'://修改运费
          that.dialogTitle = "Edit Shipping Fee";
          break;
        default:
          break;
      }
      that.$refs.DialogOrder.CardInfo = obj;
      that.$refs.DialogOrder.dialogType = type;
      that.$refs.DialogOrder.DialogShow = true;
    },
    // 关闭弹框
    DialogSwitch(dialog) {
      /* dialog Close */
      this.$refs.DialogOrder.DialogShow = false;
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
        this.timeLeng++;
      }, 1000);
    },
    // 倒计时
    endingTime(time) {
      let newval = this.$store.getters.setUTC(this.nowData, -8)
      return this.$store.getters.endingTime(time, 24)
    },
    // 秒倒计时
    timeCountDown(time) {
      time -= this.timeLeng;
      var res = "00:00";
      if (time >= 0) {
        res = this.$store.getters.timeCountDown(time);
      }
      if (res == "00:00") {
        this.$emit('MsgTabs', this.sellOrderType, this.tabname)
      }
      return res
    },
    blackUserDialog(obj) {
      console.log("blackUserDialog", obj);
      //用户拉黑
      let that = this;
      that.blackItem = obj;
      that.dialogBlackVisible = true;
    },
    blackUser(obj) {
      let that = this;
      that.$post('OperateBlack', { TargetId: obj.BuyMemberID, Type: 1, mbname: 'web' }) //拉黑用户
        .then((res) => {
          if (res.result) {
            that.$message({
              showClose: true,
              message: res.msg || 'Successful',
              type: "success",
            });
            that.dialogBlackVisible = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  font-family: Arial-Regular, Arial;
  font-weight: 400;
}

/* head */
.body_title {
  display: block;
}

.message_head {
  height: 164px;
  display: flex;
}

.head_left {
  width: 25%;
}

.order_number {
  color: #c8c8c8;
}

.to_be_paid {
  font-size: 22px;
  text-align: center;
}

.to_be_paid2 {
  font-size: 22px;
  height: 148px;
  line-height: 130px;
  text-align: center;
  color: #f0ad4e;
}

.edit_fee {
  width: 146px;
  height: 40px;
  background: #5f6dae;
  color: #ffffff;
  display: block;
  margin: 0 auto 16px;
}

.head_right {
  padding: 42px 0;
  width: 76%;
}

.plannedSpeed {
  width: 152px;
}

.planned_speed {
  display: flex;
}

.time {
  display: inline-block;
  font-size: 12px;
}

.planned_speed:nth-child(1n) {
  justify-content: flex-end;
}

.plannedSpeed .planned_speed {
  justify-content: flex-end;
  margin: 0 3.2px 0 0;
}

.plannedSpeed:last-child .planned_speed {
  justify-content: flex-start;
}

.dot {
  display: block;
  border-radius: 50%;
  background: #c8c8c8;
}

.small_dot {
  width: 6px;
  height: 6px;
  margin: 8px 0 0 20px;
}

.big_dot {
  width: 10px;
  height: 10px;
  margin: 6px 0 0 16.8px;
}

.dot_green {
  background: #58a800;
}

.planned_name {
  display: flex;
  margin: 16px 0 8px;
  color: #a0a0a0;
  padding: 0 12px;
}

.name_black {
  text-align: center;
  color: #333;
  display: block;
  margin: 16px 0 8px 10px;
}

/* info */
.list_box {
  margin: 27px 0 0;
}

.info_font_size {
  font-size: 16px;
  margin: 0 0 16px 0;
}

.info {
  display: flex;
  position: relative;
}

.info span {
  display: block;
}

.lists {
  color: #a0a0a0;
  margin: 0 0 8px 0;
}

.info-block {
  line-height: 1.6;
  display: flex;
}

.info_lists {
  min-width: 220px;
  padding-right: 20px;
}

.submit {
  width: 24px;
  height: 24px;
  background: url(../../../static/images/icon_submit_green.svg);
}

.order {
  width: 24px;
  height: 24px;
  background: url(../../../static/images/icon_porder.svg);
}

.car {
  width: 24px;
  height: 24px;
  background: url(../../../static/images/icon_car.svg);
}

.finish {
  width: 24px;
  height: 24px;
  background: url(../../../static/images/icon_finish.svg);
}

.submit_green {
  width: 24px;
  height: 24px;
  background: url(../../../static/images/icon_submit_green.svg);
}

.order_green {
  width: 24px;
  height: 24px;
  background: url(../../../static/images/icons/icon_bill.svg);
}

.car_green {
  width: 24px;
  height: 24px;
  background: url(../../../static/images/icons/icon_express_delivery.svg);
}

.finish_green {
  width: 24px;
  height: 24px;
  background: url(../../../static/images/icons/icon_correct.svg);
}

.shipping_address_box {
  margin: 16px 0 0;
}

.submit_orders {
  margin: 16px 0 8px 0;
}

/* details */

/* total */
.total_price {
  /* float: right; */
  margin: 24px 0 0;
  text-align: right;
}

.total_price div {
  margin: 0 0 20px;
}

.total_box {
  font-size: 24px;
  color: #e02020;
}

.item_price,
.shipping_fee,
.total {
  margin: 0 16px 0 0;
}

.dot_right {
  margin: 8px 20px 0 20px;
}

.Remaining_time {
  width: 100%;
  font-size: 12px;
  line-height: 1.5;
  margin: 4px 0 8px;
  text-align: center;
}

.count_down {
  background: url(../../../static/images/timing.svg) no-repeat;
  background-position: -1px 0px;
  padding: 0 0 0 15px;
}

.Remaining_red {
  background: url(../../../static/images/timing_red.svg) no-repeat;
  background-position: -1px 3px;
}

.order_pt div:nth-child(2) {
  margin: 4px auto 8px;
}

.order_pt {
  height: 148px;
  line-height: 50px;
}

.info .user_name_box {
  display: flex;
  align-items: center;
}

.user_img {
  width: 24px;
  height: 24px;
  margin: 0 10px 0 0;
  border-radius: 50%;
  cursor: pointer;
}

.to-be-black {
  background: url(../../../static/images/icons/beBlack.svg) no-repeat center #f7f7f7;
  background-size: 70% auto;
  border-radius: 100%;
  cursor: pointer;
  display: inline-block;
  width: 28px;
  height: 28px;
  margin-left: 8px;
  opacity: 0.5;
}

.to-be-black:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/detail.vue